// This is a generated file. Any changes made directly in this file will be overwritten.
import * as React from 'react';
import { createSvgIcon } from '@bb-ui/react-library/dist/internal/icons';

export const FormatTextDefault = createSvgIcon(
  { LeftToRight: <React.Fragment><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M23 12.7857L20.2143 10l-9.2857 9.2857L10 23l3.7143-.9286L23 12.7857z" /><path fill="currentColor" stroke="transparent" d="M9.6685.0002a.9999.9999 0 01.9343.599l4.5029 10.2922-1.5107 1.5368L9.734 3.603 5.234 15H11c.0218 0 .0435.0007.065.0021L9.101 17H4.4443l-2.514 6.3673c-.203.5137-.7838.7657-1.2975.5628-.5137-.2028-.7657-.7837-.5628-1.2974l8.6867-22a1 1 0 01.912-.6325z" /></React.Fragment>, },
  'default'
);
